import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Text } from 'foundations-components/components/Text';
import { CollectionProcess, SubscriptionStatus } from 'commerce-subscription-lib/public/types';
import { isNumeric } from 'commerce-subscription-lib/public/utilities';
import { View } from 'foundations-components/components/View';
import { MaybeEditableSubscriptionStatus } from './MaybeEditableSubscriptionStatus';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function SubscriptionUpdatedMessage({
  isPaused,
  lastModifiedDate,
  pausedTimestamp
}) {
  return isPaused ? /*#__PURE__*/_jsx(View, {
    marginInlineStart: "400",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      "data-test-id": "subscription-properties:paused-date",
      message: "subscriptions.SubscriptionProperties.pausedLabel",
      options: {
        formattedDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: pausedTimestamp,
          format: "ll"
        })
      }
    })
  }) : /*#__PURE__*/_jsx(View, {
    marginInlineStart: "400",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      "data-test-id": "subscription-properties:last-modified-date",
      message: "subscriptions.SubscriptionProperties.lastModifiedLabel",
      options: {
        formattedDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: lastModifiedDate,
          format: "ll"
        })
      }
    })
  });
}
export function SubscriptionProperties({
  lastModifiedDate,
  upcomingLineItems,
  objectId,
  status,
  editableAreas,
  nextPaymentDate,
  collectionProcess
}) {
  var _upcomingLineItems$le;
  const hasLastModifiedDate = isNumeric(lastModifiedDate);
  const isPaused = status.value === SubscriptionStatus.Paused;
  const hasModifiedLineItems = ((_upcomingLineItems$le = upcomingLineItems === null || upcomingLineItems === void 0 ? void 0 : upcomingLineItems.length) !== null && _upcomingLineItems$le !== void 0 ? _upcomingLineItems$le : 0) > 0;
  const showHasUpcomingChangesMessage = status.value !== SubscriptionStatus.Canceled && !isPaused && hasLastModifiedDate && hasModifiedLineItems;
  const showSubscriptionUpdatedMessage = hasLastModifiedDate || isPaused;
  const showPaymentDateMessage = !!(nextPaymentDate && collectionProcess === CollectionProcess.AutomaticPayments && status.value === SubscriptionStatus.Scheduled);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      children: [status && /*#__PURE__*/_jsx(View, {
        blockSize: showPaymentDateMessage ? '22px' : 'auto',
        marginInlineStart: "400",
        "data-test-id": "subscription-properties:status",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(MaybeEditableSubscriptionStatus, {
          objectId: objectId,
          editableAreas: editableAreas,
          subscriptionStatus: status
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: showPaymentDateMessage && /*#__PURE__*/_jsx(View, {
          marginInlineStart: "400",
          children: /*#__PURE__*/_jsx(Text, {
            textTransform: "none",
            color: "text-core-subtle",
            truncate: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              "data-test-id": "subscription-properties:next-payment-date",
              message: "subscriptions.SubscriptionProperties.nextPaymentDate",
              options: {
                formattedDate: I18n.moment.utc(nextPaymentDate).format('ll')
              }
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Box, {
      children: showSubscriptionUpdatedMessage && /*#__PURE__*/_jsx(SubscriptionUpdatedMessage, {
        isPaused: isPaused,
        lastModifiedDate: lastModifiedDate,
        pausedTimestamp: status.timestamp
      })
    }), showHasUpcomingChangesMessage && /*#__PURE__*/_jsx(View, {
      marginInlineStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "subscriptions.SubscriptionProperties.editsForNextBilling",
        "data-test-id": "subscription-properties:upcoming-changes"
      })
    })]
  });
}